import { createFileRoute } from "@tanstack/react-router";
import AdminAIGenerationAttempts from "@/pages/AdminAIGenerationAttempts";

export const Route = createFileRoute("/admin/ai-attempts/")({
  component: AdminAIGenerationAttempts,
});
